import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { AppContext } from "./context/AppContext";
import { SocketValueContext } from "./context/socketContext";
import { startVersionWatcher } from "./versionWatcher";
import Maintenance from "./feature-module/Maintenance";
import MaintenanceWrapper from "./MaintenanceWrapper";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
startVersionWatcher((oldV, newV) => {
  console.log(`New version detected: ${oldV} -> ${newV}`);
});

const isMaintenanceTime = () => {
  const now = new Date();

  const indiaTime = new Date(
    now.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    })
  );

  const hour = indiaTime.getHours();

  return hour >= 0 && hour < 4;
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContext>
        <SocketValueContext>
          <BrowserRouter basename={base_path}>
            {/* <MaintenanceWrapper> */}
              <ALLRoutes />
            {/* </MaintenanceWrapper> */}
          </BrowserRouter>
        </SocketValueContext>
      </AppContext>
    </Provider>
  </React.StrictMode>
);
